export const MobileSvg = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
    <path d="M18 1H6C4.89 1 4 1.89 4 3V21C4 22.11 4.89 23 6 23H18C19.11 23 20 22.11 20 21V3C20 1.89 19.11 1 18 1ZM18 19H6V5H18V19ZM12 6C10.34 6 9 7.34 9 9C9 10.31 9.84 11.42 11 11.83V16H13V11.83C14.16 11.42 15 10.31 15 9C15 7.34 13.66 6 12 6Z" />
  </svg>
);
